'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import { getParameter } from '../../../core/utils.js';


var WinresOmalomaRequestAccountRecoveryController = function () {
  function WinresOmalomaRequestAccountRecoveryController($scope, omalomaService, $location) {
    var _this = this;

    _classCallCheck(this, WinresOmalomaRequestAccountRecoveryController);

    this.$scope = $scope;
    this.omalomaService = omalomaService;
    this.$location = $location;

    // Current status. Possible values:
    // init - Initializing.
    // enter_address - Ask user for email address to send recovery mail to.
    // sending_email - In process of asking backend to send the mail.
    // done - Email sent (if address was found). NOTE: Doesn't tell if it was, to prevent info leak.
    this.setStatus('init', null);

    // An error to be displayed. Passed to i18next.
    // Example error: Sending email failed for some reason.
    this.$scope.error = null;

    this.email = "";

    this.$scope.$on('account-recover-done', function () {
      return _this.setStatus('recover-done', null);
    });
  }

  _createClass(WinresOmalomaRequestAccountRecoveryController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.setStatus('enter_address', null);
      this.$scope.$on('login', function () {
        return _this2.setStatus('enter_address', null);
      });

      this.readRecoverUrlParams();
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('[WORAR] Set status to', status);
      if (error !== undefined) {
        if (error) console.log('[WORAR] Error:', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'send',
    value: function send(email) {
      var _this3 = this;

      this.setStatus('sending_email', null);
      var q = this.omalomaService.sendAccountRecoveryMail(this.connectionName, email);
      q.then(function (result) {
        if (result) {
          // NOTE: This simply means the backend responded and didn't encounter an error.
          // An email was only sent if the address was actually in the database.
          // The backend doesn't say whether it was to avoid an information leak.
          _this3.setStatus('done', null);
          _this3.onDone({ email: email });
        } else {
          // NOTE: False here means an error occurred.
          _this3.setStatus('enter_address', 'malfunction');
        }
      }, function (error) {
        console.error('[WORAR] Failed to send email:', error);
        _this3.setStatus('enter_address', 'malfunction');
      });
    }
  }, {
    key: 'readRecoverUrlParams',
    value: function readRecoverUrlParams() {
      var action = this.$location.search().action;
      var email = this.$location.search().email;
      var token = this.$location.search().token;

      if (action === 'rp') {
        this.goToRecoveryPhase(email, token);
        this.clearRecoverUrlParams();

        // Hack to open Wordpress forgot password tab.
        // There isn't a better way to do this.
        setTimeout(function () {
          document.querySelector('a[href="#tab-1524726437006-5-3"]').click();
        }, 5000);
      }
    }
  }, {
    key: 'clearRecoverUrlParams',
    value: function clearRecoverUrlParams() {
      this.$location.search('action', null);
      this.$location.search('email', null);
      this.$location.search('token', null);
    }

    // On click "I already have recover token" or url email or url token.

  }, {
    key: 'goToRecoveryPhase',
    value: function goToRecoveryPhase(email, token) {
      this.setStatus('done', null);
      this.onDone({ email: email, token: token });
    }
  }]);

  return WinresOmalomaRequestAccountRecoveryController;
}();

WinresOmalomaRequestAccountRecoveryController.$inject = ['$scope', 'omalomaService', '$location'];

_module3.default.component('winresOmalomaRequestAccountRecovery', {
  template: require('./winresOmalomaRequestAccountRecovery.html'),
  controller: WinresOmalomaRequestAccountRecoveryController,
  require: {},
  bindings: {
    connectionName: '@',
    onDone: '&'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaRequestAccountRecovery/winresOmalomaRequestAccountRecovery.js
// module id = 357
// module chunks = 2